import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2033 5.0566C14.5227 7.63473 11.4881 10.9389 10.8607 11.6886C9.48901 13.3276 8.45312 15.063 8.45312 17.2654C8.45312 19.3134 9.25446 21.1727 10.5579 22.5414L15.1603 27.193C15.2712 27.3054 15.4033 27.3945 15.5489 27.4553C15.6945 27.5161 15.8508 27.5473 16.0086 27.5472C16.1664 27.547 16.3227 27.5155 16.4682 27.4544C16.6137 27.3933 16.7456 27.3039 16.8562 27.1914L21.4427 22.5414C22.7461 21.1727 23.5475 19.3134 23.5475 17.2653C23.5475 16.5979 23.4624 15.9505 23.3026 15.3336L23.3079 15.3312C23.3079 15.3312 22.5891 12.1885 20.1931 8.32024C20.1931 9.91012 19.7936 11.1449 19.1575 12.2194C18.4576 9.9588 17.0449 7.23567 14.2033 5.0566Z",
			fill: "#E25345"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5334 25.9967C16.2387 26.2909 15.7607 26.2909 15.466 25.9967L12.2529 22.7892C11.2837 21.8281 10.6836 20.4967 10.6836 19.0253C10.6836 16.0949 13.0637 13.7193 15.9997 13.7193C18.9357 13.7193 21.3158 16.0949 21.3158 19.0253C21.3158 20.4967 20.7157 21.8281 19.7465 22.7892L16.5334 25.9967Z",
			fill: "#EF8939"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9998 16.9208C17.8238 16.9208 19.3024 18.3965 19.3024 20.217C19.3024 21.1313 18.9305 21.9573 18.3274 22.5553L18.3264 22.5562L18.3255 22.5572L16.2667 24.6124C16.1193 24.7595 15.8803 24.7595 15.733 24.6124L13.6741 22.5572L13.6732 22.5562L13.6722 22.5553C13.088 21.976 12.7208 21.1827 12.6984 20.3025L12.6973 20.217C12.6973 18.3965 14.1759 16.9208 15.9998 16.9208Z",
			fill: "#FBC02D"
		})
	]
});
export default SvgLogo;
